import * as React from 'react';
import { ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import FormSelect from './FormSelect';
import { Translate } from '../../shared/LanguageService';
import FormValidationService from '../../shared/form/FormValidationService';

interface ILanguageSelectProps {
    onChange: (e: any) => void;
    languageKey: string;
    errors: any;
    controlLabelTranslationKey?: string;
    languages: any[];
}

const LanguageSelect = (props: ILanguageSelectProps) => {
    return (
        <FormGroup
            className="required"
            validationState={FormValidationService.getValidationState(
                props.errors ? props.errors.languageKey : ''
            )}
        >
            <ControlLabel>
                {props.controlLabelTranslationKey
                    ? Translate(props.controlLabelTranslationKey)
                    : Translate('language/select-label/language')}
            </ControlLabel>
            <FormSelect
                name="languageKey"
                value={props.languageKey}
                placeholder=""
                onChange={props.onChange}
                defaultTranslateKey="language/select-label/placeholder/select-language"
            >
                {props.languages.map((x: any) => {
                    return (
                        <option key={x.id} value={x.id}>
                            {Translate(x.name)}
                        </option>
                    );
                })}
            </FormSelect>
            {props.errors && <HelpBlock>{props.errors.languageKey}</HelpBlock>}
        </FormGroup>
    );
};

export default LanguageSelect;
